import { ConfirmationCodeMethod } from "../../@types/ConfirmationCode";
import { api } from "../api";

export default async function createPhoneCode(
  phone: string,
  method: ConfirmationCodeMethod
): Promise<string> {
  try {
    const { data } = await api.post("/confirmation-code/phone-code", {
      method,
      sendTo: phone,
    });

    return data.message;
  } catch (err: any) {
    console.error(err);

    return err.response.data.message;
  }
}
